/*var clientResumeBo = {
    numero: 0,
    ligne1: '',
    ligne2: '',
};*/

var clientResumeBo = {
    numero: '20156454',
    ligne1: 'Huntblueblade Sonmelas',
    ligne2: 'Huntblueblade Sonmelasef',
};

export default clientResumeBo;


// WEBPACK FOOTER //
// ./src/components/data/devis/ClientResume.js